// Lidský název typu souboru místo MIME („Dokument PDF“ místo application/pdf) – Soubory, Vlastnosti, podokno podrobností,
// přílohy v Poště. Neznámý typ podle přípony („Soubor BIN“), MIME zůstává v nápovědě (title) a ve Vlastnostech.
import { t } from './i18n';

/** Přípona z názvu souboru (velkými písmeny, bez tečky), nebo ''. */
function ext(name: string | null | undefined): string {
  const m = /\.([A-Za-z0-9]{1,8})$/.exec(name ?? '');
  return m ? (m[1] ?? '').toUpperCase() : '';
}

/** Kratší podtyp MIME do názvu (jpeg → JPG, svg+xml → SVG, x-matroska → MKV). */
function sub(mime: string): string {
  const s = (mime.split('/')[1] ?? '').split(';')[0] ?? '';
  const map: Record<string, string> = { jpeg: 'JPG', 'svg+xml': 'SVG', 'x-icon': 'ICO', 'vnd.microsoft.icon': 'ICO', mpeg: 'MPEG', quicktime: 'MOV', 'x-matroska': 'MKV', 'x-msvideo': 'AVI', 'x-wav': 'WAV', wav: 'WAV', 'x-m4a': 'M4A', mp4: 'MP4', ogg: 'OGG', webm: 'WEBM' };
  return map[s] ?? s.replace(/^(x-|vnd\.)/, '').toUpperCase();
}

const OFFICE: [RegExp, string, string][] = [
  [/(msword|wordprocessingml)/, 'doc', 'Word'],
  [/opendocument\.text/, 'doc', 'ODT'],
  [/(rtf)$/, 'doc', 'RTF'],
  [/(ms-excel|spreadsheetml)/, 'sheet', 'Excel'],
  [/opendocument\.spreadsheet/, 'sheet', 'ODS'],
  [/(ms-powerpoint|presentationml)/, 'slides', 'PowerPoint'],
  [/opendocument\.presentation/, 'slides', 'ODP'],
];
const ARCHIVE: Record<string, string> = { 'application/zip': 'ZIP', 'application/x-zip-compressed': 'ZIP', 'application/x-7z-compressed': '7Z', 'application/vnd.rar': 'RAR', 'application/x-rar-compressed': 'RAR', 'application/gzip': 'GZ', 'application/x-gzip': 'GZ', 'application/x-tar': 'TAR', 'application/x-bzip2': 'BZ2' };

/** Název typu pro člověka; folder / shortcut řeší volající (Složka, Zástupce). */
export function mimeLabel(mime: string | null | undefined, name?: string | null): string {
  const m = (mime ?? '').toLowerCase();
  const e = ext(name);
  if (m === 'application/x-iwan-shortcut') return t('core.mime.shortcut');
  if (m === 'application/pdf') return t('core.mime.pdf');
  if (m.startsWith('image/')) return t('core.mime.image', { ext: sub(m) || e });
  if (m.startsWith('video/')) return t('core.mime.video', { ext: sub(m) || e });
  if (m.startsWith('audio/')) return t('core.mime.audio', { ext: e || sub(m) });
  if (m === 'text/plain') return t('core.mime.text');
  if (m === 'text/csv') return t('core.mime.sheet', { ext: 'CSV' });
  if (m === 'text/html') return t('core.mime.html');
  if (m === 'text/markdown') return t('core.mime.markdown');
  if (m === 'text/calendar') return t('core.mime.ical');
  if (m === 'text/vcard' || m === 'text/x-vcard') return t('core.mime.vcard');
  if (m === 'message/rfc822') return t('core.mime.email');
  if (m === 'application/json') return t('core.mime.data', { ext: 'JSON' });
  if (m === 'application/xml' || m === 'text/xml') return t('core.mime.data', { ext: 'XML' });
  for (const [re, kind, label] of OFFICE) if (re.test(m)) return t('core.mime.' + kind, { ext: label });
  if (ARCHIVE[m]) return t('core.mime.archive', { ext: ARCHIVE[m] });
  if (m.startsWith('text/')) return t('core.mime.text_of', { ext: e || sub(m) });
  return e ? t('core.mime.file_of', { ext: e }) : t('core.mime.file');
}
